export default {"src":"/_next/static/media/red_cross_icon.401d6aa5.svg","height":79,"width":79,"blurWidth":0,"blurHeight":0};